<template>
  <div
    class="flex flex-col gap-6 cursor-pointer bg-primary-dark text-zinc-50 rounded-2xl overflow-clip w-full"
    @click="open()"
  >
    <div class="relative">
      <img
        :src="video.thumbnails.high.url"
        :alt="video.title"
        class="w-full h-48 object-cover"
      >

      <img
        src="/icon.svg"
        class="absolute -top-6 -right-0 z-3 w-1/4 h-auto"
      >
    </div>

    <section class="flex flex-col p-3 md:p-6 lg:p-12 h-full">
      <p class="text-xl lg:text-2xl">
        {{ video.title }}
      </p>
      <div class="flex-1 pt-3 pb-6">
        <p class="line-clamp-2 break-words break-all">
          {{ video.description }}
        </p>
      </div>
      <ButtonBasic
        class="cursor-pointer mt-6 "
        theme="dark"
        @click="open()"
      >
        View Session
      </ButtonBasic>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useModal } from 'vue-final-modal'

import { JournalModal } from '#components'

const { video } = defineProps<{ video: YouTubeVideo }>()

const { open, close } = useModal({
  component: JournalModal,
  attrs: {

    onConfirm() {
      close()
    },
    video: video,
  },
})
</script>

<style scoped>

</style>
